import React, { useState } from 'react';
import {
  Container,
  Typography,
  Grid,
  Card,
  CardMedia,
  Box,
  Modal,
  IconButton,
  Tabs,
  Tab,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import PublicIcon from '@mui/icons-material/Public';
import EventIcon from '@mui/icons-material/Event';
import ConstructionIcon from '@mui/icons-material/Construction'; 
import PetsIcon from '@mui/icons-material/Pets';
import NewspaperIcon from '@mui/icons-material/Newspaper';
import '../pages/Gallery.css';

const gallerySections = {
  village: [

    { src: 'viral7.mp4', title: 'बडिंग नॅचरलिस्ट अवॉर्ड 2023 चिन्मय सावंत 🏆🌿 ' ,type:'video'},
   
    { src: 'viral1.mp4', title: 'किरकसाल जैवविविधता व्यवस्थापन समिती मार्फत वणवा जनजागृती अभियान 🌿' ,type:'video'},
   
    { src: '/wetland_video.mp4', title: 'इंटरनेट Virals ' ,type:'video'},
    { src: 'kirksal_introduction.mp4', title: 'किरकसाल गाव ' ,type:'video'},
    { src: 'viral2.mp4', title: 'पटेरी  तरसींन ' ,type:'video'},
    { src: 'viral3.mp4', title: 'Glimpse Of Kirksal Conservation Project' ,type:'video'},
    { src: 'viral4.mp4', title: '🌿 माणदेशातील जैवविविधता संवर्धनासाठी आदर्शगाव किरकसालचे ‘मॉडेल’ तयार! 🏡✨' ,type:'video'},
    { src: 'viral5.mp4', title: 'Camera Traps Drive Conservation Efforts in Kirksal' ,type:'video'},


    { src: 'viral6.mp4', title: '🌿 A Day at a Waterhole 💧🐾' ,type:'video'},
   
   
   
   
  ],
  events: [
    { src: 'functions/f1.jpg', title: '' ,type:'image'},
    { src: 'functions/fun1.jpg', title: '' ,type:'image'},
    { src: 'functions/fun2.jpg', title: 'दहिवडी यांच्या २०२४-२५ च्या ६ दिवसीय राष्ट्रीय सेवा योजना (NSS) विशेष श्रमसंस्कार शिबिराचे आयोजन किरकसाल येथे करण्यात आले. ' ,type:'image'},
    { src: 'functions/fun3.jpg', title: 'दहिवडी यांच्या २०२४-२५ च्या ६ दिवसीय राष्ट्रीय सेवा योजना (NSS) विशेष श्रमसंस्कार शिबिराचे आयोजन किरकसाल येथे करण्यात आले. ' ,type:'image'},
    { src: 'functions/fun4.jpg', title: 'विचारांचा दीपोत्सव किरकसाल २०२४ - ‘आदर्श वन्यजीव रक्षक पुरस्कार’ सोहळा 🐾🌿' ,type:'image'},
    { src: 'functions/fun5.jpg', title: 'किरकसालमध्ये जागतिक वन्यजीव सप्ताहाचा विशेष कार्यक्रम शाळांमध्ये उत्साहात संपन्न!' ,type:'image'},
    { src: 'functions/fun6.jpg', title: '' ,type:'image'},
    { src: 'functions/fun7.jpg', title: '' ,type:'image'},
    { src: 'functions/fun8.jpg', title: '' ,type:'image'},
    { src: 'functions/fun9.jpg', title: '' ,type:'image'},
  ],
  development: [
    { src: 'Development/dev1.jpg', title: '', type: 'image' },
    { src: 'Development/dev2.jpg', title: '' ,type:'image'},
    { src: 'Development/dev3.jpg', title: '' ,type:'image'},
    { src: 'Development/dev5.jpg', title: '' ,type:'image'},
    { src: 'Development/dev4.jpg', title: '' ,type:'image'},
    { src: 'Development/dev5.jpg', title: '' ,type:'image'},
    { src: 'Development/dev5.jpg', title: '' ,type:'image'},
    { src: 'Development/dev6.jpg', title: 'किरकसाल शाळेत वन्यजीव सप्ताहानिमित्त MTB आणि हॅबिटॅट ट्रस्टच्या संवर्धन माहितीपटाचे प्रदर्शन, विद्यार्थ्यांचा उत्स्फूर्त प्रतिसाद!' ,type:'image'},
    { src: 'Development/dev7.jpg', title: 'किरकसाल शाळेत वन्यजीव सप्ताहानिमित्त MTB आणि हॅबिटॅट ट्रस्टच्या संवर्धन माहितीपटाचे प्रदर्शन, विद्यार्थ्यांचा उत्स्फूर्त प्रतिसाद!' ,type:'image'},
    { src: 'Development/dev8.jpg', title: 'भूजल समृद्ध ग्राम स्पर्धा २०२२-२३ मध्ये किरकसाल प्रथम (₹५० लाख) व राज्यात तृतीय (₹३० लाख), बक्षीस वितरण नाशिकमध्ये संपन्न!' ,type:'image'},
    { src: 'Development/dev9.jpg', title: 'भूजल समृद्ध ग्राम स्पर्धा २०२२-२३ मध्ये किरकसाल प्रथम (₹५० लाख) व राज्यात तृतीय (₹३० लाख), बक्षीस वितरण नाशिकमध्ये संपन्न!' ,type:'image'},
    { src: 'Development/dev11.jpg', title: '' ,type:'image'},
    { src: 'Development/dev19.jpg', title: '' ,type:'image'},
    { src: 'Development/dev20.jpg', title: '' ,type:'image'},
    { src: 'Development/dev21.jpg', title: '' ,type:'image'},
    { src: 'Development/dev22.jpg', title: '' ,type:'image'},
    { src: 'Development/dev23.jpg', title: '' ,type:'image'},
    { src: 'Development/dev24.jpg', title: '' ,type:'image'},
    { src: 'Development/dev25.jpg', title: '' ,type:'image'},
    { src: 'Development/dev26.jpg', title: '' ,type:'image'},
    { src: 'Development/dev27.jpg', title: '' ,type:'image'},
    { src: 'Development/dev28.jpg', title: '' ,type:'image'},
    { src: 'Development/dev29.jpg', title: '' ,type:'image'},
    { src: 'Development/dev30.jpg', title: '' ,type:'image'},
    { src: 'Development/dev31.jpg', title: '' ,type:'image'},
    { src: 'Development/dev32.jpg', title: '' ,type:'image'},
    { src: 'Development/dev33.jpg', title: '' ,type:'image'},
    { src: 'Development/dev34.jpg', title: '' ,type:'image'},
    { src: 'Development/dev35.jpg', title: '' ,type:'image'},
    { src: 'Development/dev36.jpg', title: '' ,type:'image'},
    { src: 'Development/dev37.jpg', title: '' ,type:'image'},
    { src: 'Development/dev38.jpg', title: '' ,type:'image'},
    { src: 'Development/dev39.jpg', title: '' ,type:'image'},
    { src: 'Development/dev40.jpg', title: '' ,type:'image'},
    { src: 'Development/dev41.jpg', title: '' ,type:'image'},
    { src: 'Development/dev42.jpg', title: '' ,type:'image'},
    { src: 'Development/dev43.jpg', title: '' ,type:'image'},
    { src: 'Development/dev44.jpg', title: '' ,type:'image'},
    { src: 'Development/dev45.jpg', title: '' ,type:'image'},
    { src: 'Development/dev46.jpg', title: '' ,type:'image'},
    { src: 'Development/dev47.jpg', title: '' ,type:'image'},
    { src: 'Development/dev48.jpg', title: '' ,type:'image'},
    { src: 'Development/dev49.jpg', title: '' ,type:'image'},
    { src: 'Development/dev50.jpg', title: '' ,type:'image'},
  ],
  wwf: [


    { src: 'WWF/w36.jpg', title: 'आदर्शगाव किरकसाल "जैवविविधता वारसा स्थळ" घोषित होण्याच्या दिशेने ठोस पाऊल 🐺🌿' ,type:'image'},
    { src: 'WWF/w37.jpg', title: 'आदर्शगाव किरकसाल "जैवविविधता वारसा स्थळ" घोषित होण्याच्या दिशेने ठोस पाऊल 🐺🌿' ,type:'image'},
    { src: 'WWF/w38.jpg', title: 'आदर्शगाव किरकसाल "जैवविविधता वारसा स्थळ" घोषित होण्याच्या दिशेने ठोस पाऊल 🐺🌿' ,type:'image'},
    { src: 'WWF/w39.jpg', title: 'आदर्शगाव किरकसाल "जैवविविधता वारसा स्थळ" घोषित होण्याच्या दिशेने ठोस पाऊल 🐺🌿' ,type:'image'},
    { src: 'WWF/w40.jpg', title: 'आदर्शगाव किरकसाल "जैवविविधता वारसा स्थळ" घोषित होण्याच्या दिशेने ठोस पाऊल 🐺🌿' ,type:'image'},
    { src: 'WWF/w41.jpg', title: '🌳✨ एकत्रीत प्रयत्नांनी साधले यश: किरकसाल-डांभेवाडी वन सीमेवर फायरलाइन तयार ✨🌳' ,type:'image'},
    { src: 'WWF/w42.jpg', title: '🌳✨ एकत्रीत प्रयत्नांनी साधले यश: किरकसाल-डांभेवाडी वन सीमेवर फायरलाइन तयार ✨🌳' ,type:'image'},
    { src: 'WWF/w43.jpg', title: 'Bengal Fox – The Stealthy Guardian of Grasslands 🦊खोकड – निसर्गाचा राखणदार' ,type:'image'},
    { src: 'WWF/w44.jpg', title: 'Golden Jackal – The Unsung Hero of Grasslands Ecosystems 🌿' ,type:'image'},
    { src: 'WWF/w45.jpg', title: 'Striped Hyena – “The Pride of Kiraksal”पट्टेरी तरस – किरकसालची शान' ,type:'image'},
    { src: 'WWF/w46.jpg', title: 'Indian Wolf – “The King of Grasslands” 🐺🌿भारतीय लांडगा – गवताळ प्रदेशाचा राजा' ,type:'image'},
    { src: 'WWF/w47.jpg', title: '' ,type:'image'},
    { src: 'WWF/w48.jpg', title: 'तांबट आणि चष्मेवाला पक्षी किरकसामध्ये वडाच्या (Ficus bengalensis) वृक्षाच्या फळांचा आस्वाद घेताना! 🌳🍒' ,type:'image'},
    { src: 'WWF/w49.jpg', title: 'तांबट आणि चष्मेवाला पक्षी किरकसामध्ये वडाच्या (Ficus bengalensis) वृक्षाच्या फळांचा आस्वाद घेताना! 🌳🍒' ,type:'image'},
    { src: 'WWF/w50.jpg', title: '🙏 Grateful to @wwfindia for supporting the Kiraksal Conservation Project under CCP 2023-24! 🌿🌎',type:'image'},
    { src: 'WWF/w51.jpg', title: '🙏 Grateful to @wwfindia for supporting the Kiraksal Conservation Project under CCP 2023-24! 🌿🌎' ,type:'image'},
   
    { src: 'WWF/w1.jpg', title: '' ,type:'image'},
    { src: 'WWF/w2.jpg', title: '' ,type:'image'},
    { src: 'WWF/w3.jpg', title: '' ,type:'image'},
    { src: 'WWF/w4.jpg', title: '' ,type:'image'},
    { src: 'WWF/w5.jpg', title: '' ,type:'image'},
    { src: 'WWF/w6.jpg', title: '' ,type:'image'},
    { src: 'WWF/w7.jpg', title: '' ,type:'image'},
    { src: 'WWF/w8.jpg', title: '' ,type:'image'},
    { src: 'WWF/w9.jpg', title: '' ,type:'image'},
    { src: 'WWF/w10.jpg', title: '' ,type:'image'},
    { src: 'WWF/w11.jpg', title: '' ,type:'image'},
    { src: 'WWF/w12.jpg', title: '' ,type:'image'},
    { src: 'WWF/w13.jpg', title: '' ,type:'image'},
    { src: 'WWF/w15.jpg', title: '' ,type:'image'},
    { src: 'WWF/w16.jpg', title: '' ,type:'image'},
    { src: 'WWF/w17.jpg', title: '' ,type:'image'},
    { src: 'WWF/w18.jpg', title: '' ,type:'image'},
    { src: 'WWF/w19.jpg', title: '' ,type:'image'},
    { src: 'WWF/w20.jpg', title: '' ,type:'image'},
    { src: 'WWF/w21.jpg', title: '' ,type:'image'},
    { src: 'WWF/w22.jpg', title: '' ,type:'image'},
    { src: 'WWF/w23.jpg', title: '' ,type:'image'},
    { src: 'WWF/w24.jpg', title: '' ,type:'image'},
    { src: 'WWF/w26.jpg', title: '' ,type:'image'},
    { src: 'WWF/w27.jpg', title: '' ,type:'image'},
    { src: 'WWF/w28.jpg', title: '' ,type:'image'},
    { src: 'WWF/w29.jpg', title: '' ,type:'image'},
    { src: 'WWF/w30.jpg', title: '' ,type:'image'},
    { src: 'WWF/w31.jpg', title: '' ,type:'image'},
    { src: 'WWF/w32.jpg', title: '' ,type:'image'},
    { src: 'WWF/w33.jpg', title: '' ,type:'image'},
    { src: 'WWF/w34.jpg', title: '' ,type:'image'},
    { src: 'WWF/w35.jpg', title: '' ,type:'image'},
   
    
    
    
  ],
  newspaper: [
    { src: 'New Cutting/n1.jpg', title: '' ,type:'image'},
    { src: 'New Cutting/n2.jpg', title: '' ,type:'image'},
    { src: 'New Cutting/n3.jpg', title: '' ,type:'image'},
    { src: 'New Cutting/n4.jpg', title: '' ,type:'image'},
    { src: 'New Cutting/n5.jpg', title: '' ,type:'image'},
    { src: 'New Cutting/n7.jpg', title: '' ,type:'image'},
    { src: 'New Cutting/n8.jpg', title: '' ,type:'image'},
    { src: 'New Cutting/n9.jpg', title: '' ,type:'image'},
    { src: 'New Cutting/news1.jpg', title: '',type:'image' },
    { src: 'New Cutting/news2.jpg', title: '' ,type:'image'},
    { src: 'New Cutting/news3.jpg', title: '' ,type:'image'},
    { src: 'New Cutting/news4.jpg', title: '' ,type:'image'},
    { src: 'New Cutting/news5.jpg', title: '' ,type:'image'},
    { src: 'New Cutting/news6.jpg', title: '' ,type:'image'},
    { src: 'New Cutting/news7.jpg', title: '' ,type:'image'},
    { src: 'New Cutting/news8.jpg', title: '' ,type:'image'},
    { src: 'New Cutting/news9.jpg', title: '' ,type:'image'},
    { src: 'New Cutting/news10.jpg', title: '',type:'image' },
   
  ],
};


const tabLabels = [
  { label: 'इंटरनेट Virals', icon: <PublicIcon sx={{ color: '#1976D2' }} /> },
  { label: 'कार्यक्रम', icon: <EventIcon sx={{ color: '#E91E63' }} /> },
  { label: 'विकास', icon: <ConstructionIcon  sx={{ color: '#4CAF50' }} /> },
  { label: 'WWF संरक्षण', icon: <PetsIcon sx={{ color: '#FF9800' }} /> },
  { label: 'बातम्या कात्रण', icon: <NewspaperIcon sx={{ color: '#9C27B0' }} /> },
];

const Gallery = () => {
  const [selectedMediaIndex, setSelectedMediaIndex] = useState<number | null>(null);
  const [currentCategory, setCurrentCategory] = useState<keyof typeof gallerySections>('village');
  const [tabValue, setTabValue] = useState(0);

  const handleMediaClick = (index: number, type: string) => {
    // Prevent video from playing twice
    if (type === 'video') {
      const videoElement = document.getElementById('modal-video') as HTMLVideoElement;
      if (videoElement) {
        videoElement.play(); // Auto-play the video when modal opens
      }
    }
    setSelectedMediaIndex(index);
  };

  const handleClose = () => {
    // Stop video when modal closes
    const videoElement = document.getElementById('modal-video') as HTMLVideoElement;
    if (videoElement) {
      videoElement.pause();
      videoElement.currentTime = 0;
    }
    setSelectedMediaIndex(null);
  };

  const handlePrevious = () =>
    setSelectedMediaIndex((prev) => (prev ? prev - 1 : gallerySections[currentCategory].length - 1));
  const handleNext = () =>
    setSelectedMediaIndex((prev) =>
      prev !== null ? (prev < gallerySections[currentCategory].length - 1 ? prev + 1 : 0) : null
    );
  const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
    setTabValue(newValue);
    setCurrentCategory(Object.keys(gallerySections)[newValue] as keyof typeof gallerySections);
  };

  return (
    <Box sx={{ py: 6, backgroundColor: 'background.default' }}>
      <Container maxWidth="lg">
        <Box sx={{ textAlign: 'center', mb: 6 }}>
          <Typography variant="h3" gutterBottom>फोटो गॅलरी</Typography>
          <Typography variant="h6" color="text.secondary">आमच्या गावाचे सौंदर्य आणि विकास पहा</Typography>
        </Box>


       {/* Responsive Tabs with Colors */}
      <Tabs
        value={tabValue}
        onChange={handleTabChange}
        variant="scrollable"
        scrollButtons="auto"
        allowScrollButtonsMobile
        sx={{
          width: "100%", // Ensures full width
          display: "flex",
          
          justifyContent: "center", // 🔹 Forces center alignment in full screen
          alignItems: "center",
          "& .MuiTabs-flexContainer": {
            justifyContent: "center", // 🔹 Centers tabs properly
            flexWrap: "wrap", // Allows proper wrapping if needed
          },
          "& .MuiTab-root": {
            minWidth: "auto",
            padding: "10px 16px",
      fontSize: "1rem",
    },
  }}
>
  {tabLabels.map((tab, index) => (
    <Tab key={index} icon={tab.icon} label={tab.label} />
  ))}
</Tabs>





        <Grid container spacing={3} sx={{ mt: 3 }}>
          {gallerySections[currentCategory].map((media, index) => (
            <Grid item xs={12} sm={6} md={4} key={index}>
              <Card onClick={() => handleMediaClick(index, media.type)} className="gallery-card">
                {media.type === 'video' ? (
                  <Box sx={{
                    position: 'relative',
                    width: '100%',
                    height: '200px',
                    overflow: 'hidden',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                  }}>
                    <video
                      width="100%"
                      height="100%"
                      style={{
                        objectFit: 'cover', // 🔹 Ensures video fits correctly in grid
                        borderRadius: '8px',
                      }}
                      controls
                      onClick={(e) => e.stopPropagation()}
                    >
                      <source src={media.src} type="video/mp4" />
                      Your browser does not support the video tag.
                    </video>
                  </Box>
                ) : (
                  <CardMedia component="img" height="200" image={media.src} alt={media.title} />
                )}
                <Box className="gallery-title">
                  <Typography variant="body1">{media.title}</Typography>
                </Box>
              </Card>
            </Grid>
          ))}
        </Grid>

        {/* Media Modal */}
        <Modal open={selectedMediaIndex !== null} onClose={handleClose} className="modal-container">
          <Box
            className="modal-content"
            sx={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              flexDirection: 'column',
              width: '100vw',
              height: '100vh',
              backgroundColor: 'rgba(0, 0, 0, 0.9)',
              padding: 2,
              borderRadius: '12px',
              boxShadow: 5,
            }}
          >
            {selectedMediaIndex !== null && (
              <>
                <IconButton onClick={handleClose} className="modal-close">
                  <CloseIcon sx={{ color: "white" }} />
                </IconButton>
                <IconButton onClick={handlePrevious} className="modal-nav left">
                  <ChevronLeftIcon sx={{ color: "white" }} />
                </IconButton>
                <IconButton onClick={handleNext} className="modal-nav right">
                  <ChevronRightIcon sx={{ color: "white" }} />
                </IconButton>

                {gallerySections[currentCategory][selectedMediaIndex].type === 'video' ? (
                  <video
                    id="modal-video"
                    controls
                    autoPlay
                    style={{
                      maxWidth: '90vw', // 🔹 Ensures video doesn't go beyond screen width
                      maxHeight: '90vh', // 🔹 Ensures video doesn't go beyond screen height
                      objectFit: 'contain', // 🔹 Maintains aspect ratio without cropping
                      borderRadius: '8px',
                    }}
                  >
                    <source src={gallerySections[currentCategory][selectedMediaIndex].src} type="video/mp4" />
                    Your browser does not support the video tag.
                  </video>
                ) : (
                  <img
                    src={gallerySections[currentCategory][selectedMediaIndex].src}
                    alt={gallerySections[currentCategory][selectedMediaIndex].title}
                    style={{
                      maxWidth: '90%',
                      maxHeight: '90vh',
                      borderRadius: '8px',
                    }}
                  />
                )}
              </>
            )}
          </Box>
        </Modal>
      </Container>
    </Box>
  );
};

export default Gallery;
